import { Injectable } from '@angular/core';
import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';
import { Position } from './position.model';

export interface PositionsState extends EntityState<Position> {
    ui: {
        includeNetted: boolean /* positions that are zero (sold off) */;
        updatedAt: Date | null;
    };
}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'positions' })
export class PositionsStore extends EntityStore<PositionsState> {
    constructor() {
        super({
            ui: {
                includeNetted: false,
                updatedAt: null
            }
        });
    }
    akitaPreAddEntity(position: Position) {
        if (!position.id) {
            const id = position.position.positionId;
            const cashInBaseCurrency =
                position.instrument.type === 'CASH'
                    ? position.marketValueInBaseCurrency
                    : 0;
            return {
                ...position,
                cashInBaseCurrency,
                acquisitionValue:
                    position.position.quantity * position.position.acquisitionPriceAvg,
                id
            };
        }
        return position;
    }

    akitaPreUpdateEntity(prevPosition: Position, nextPosition: Position) {
        // return the same entity or modify it
        return nextPosition;
    }
}
